module.exports = __webpack_public_path__ + "static/media/จอ.d8bdd63c.jpg";